import { render, staticRenderFns } from "./TitleColor.vue?vue&type=template&id=0cb7c1e6&scoped=true&"
import script from "./TitleColor.vue?vue&type=script&lang=js&"
export * from "./TitleColor.vue?vue&type=script&lang=js&"
import style0 from "./TitleColor.vue?vue&type=style&index=0&id=0cb7c1e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7c1e6",
  null
  
)

export default component.exports